export class ConfigurationModel {
    logoFileName: string;
    clientName:string;
    isThemechanged?:boolean;
    url?: string;
    isCorporateUser?: boolean;
    loginBGImage?:string;
    loginLogo?:string;
    loginMarketingDesc?:string;
    
    
    constructor(){
        this.logoFileName = '/content/images/ProductLogo2.jpeg';
        this.clientName = 'Xeeva';

        //this.isThemechanged = false;
    }
      // public get clientLogo(): string {
    //     return this.LOGOFileName;
    // }
    // public set clientLogo(value: string) {
    //     this.LOGOFileName = value;
    // }
}
